import React from "react";
import { Container, Row, Col, Card, Button } from 'react-bootstrap'

function Pre(props) {
  return <div id={props.load ? "preloader" : "preloader-none"}>Loading ...</div>
}

export default Pre;
